/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import {
  IPricingValue,
  IResponseListPricingValues,
  IResponseShowPricingValue,
} from "../../interfaces/pricingValues";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/pricing_values";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listPricingValues({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListPricingValues>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showPricingValue({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowPricingValue>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createPricingValue({
  pricingValue,
}: {
  pricingValue: IPricingValue;
}) {
  const { data } = await api.post<IResponseShowPricingValue>(BASE, {
    pricingValue,
  });
  return data;
}

export async function updatePricingValue({
  id,
  pricingValue,
}: {
  id: string | number;
  pricingValue: IPricingValue;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowPricingValue>(url, {
    pricingValue,
  });
  return data;
}
export async function deletePricingValue({
  id
}: {
  id: string | number
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.delete<IResponseShowPricingValue>(url);
  return data;
}
